const Loader = (props) => {
  return (
    <>
      <div>"Loading..."</div>
    </>
  );
};

export default Loader;
